import React from 'react';
import { useState, useEffect, useRef } from "react";
import { Column } from "@ant-design/plots";
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDashboardData } from '../../slices/dashboard';

const Graph1 = ({ dateRange }) => {
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  const containerRef = useRef(null);
  const { data = {}, loading } = useSelector((state) => state.dashboard);

  const types = ['Work Orders', 'Total Packing', 'Total Dispatched'];
  const colors = ['#4299E1', '#38B2AC', '#48BB78']; 
  const colorMap = {
    "Work Orders": "#4299E1",
    "Total Packing": "#38B2AC",
    "Total Dispatched": "#48BB78",
  };
  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        setContainerSize({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight,
        });
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  const chartData = React.useMemo(() => {
    if (!data.graph_data || Object.keys(data.graph_data).length === 0) {
      return [];
    }

    return Object.entries(data.graph_data).map(([date, values]) => ([
      {
        date: dayjs(date, 'DD-MM-YYYY').format('DD-MM'),
        type: 'Work Orders',
        value: Number(values.total_kgs || 0)
      },
      {
        date: dayjs(date, 'DD-MM-YYYY').format('DD-MM'),
        type: 'Total Packing',
        value: Number(values.total_packing_kgs || 0)
      },
      {
        date: dayjs(date, 'DD-MM-YYYY').format('DD-MM'),
        type: 'Total Dispatched',
        value: Number(values.total_dispatched_kgs || 0)
      }
    ])).flat().sort((a, b) => {
      const dateA = dayjs(a.date, 'DD-MM');
      const dateB = dayjs(b.date, 'DD-MM');
      return dateA.diff(dateB);
    });
  }, [data.graph_data]);

  const transformedData = React.useMemo(() => {
    if (!data.graph_data || Object.keys(data.graph_data).length === 0) {
      return [];
    }

    return Object.entries(data.graph_data).flatMap(([date, values]) => [
      { date: dayjs(date, 'DD-MM-YYYY').format('DD'), type: "Work Orders", value: values?.total_kgs },
      { date: dayjs(date, 'DD-MM-YYYY').format('DD'), type: "Total Packing", value: values?.total_packing_kgs },
      { date: dayjs(date, 'DD-MM-YYYY').format('DD'), type: "Total Dispatched", value: values?.total_dispatched_kgs },
    ]);
  }, [data.graph_data]);
 
  const config = {
    data: transformedData,
    group: true,
    xField: "date",
    yField: "value",
    seriesField: "type",
    colorField: 'type',
    style: {
      inset: 5,
    },
    columnStyle: {
      radius: [4, 4, 0, 0],
    },
  };

 
  return (
    <div>
      <div ref={containerRef} style={{ width: "100%", height: "400px" }}>
        {loading ? (
          <div style={{ 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: '#718096',
            fontSize: '14px',
            fontWeight: 500
          }}>
            Loading...
          </div>
        ) : chartData.length === 0 ? (
          <div style={{ 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: '#718096',
            fontSize: '14px',
            fontWeight: 500
          }}>
            No data available for the selected date range
          </div>
        ) : (
          <Column {...config} />
        )}
      </div>
    </div>
  );
};

export default Graph1;